<template>
    <v-list-item :link="!!to" :to="to">
        <v-list-item-action v-if="icon">
            <v-icon>{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: "NavItem",
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: null
        },
        to: {
            type: [String, Object],
            default: null
        }
    }
};
</script> 